import * as types from './types'
import http from '@/Plugins/api'

export default {
  setPager({ commit }, data) {
    commit(types.SET_PAGER, data)
  },
  setChecked({ commit }, data) {
    commit(types.SET_CHECKED, data)
  },
  resetChallenge({ commit }, data) {
    commit(types.RESET_CHALLENGE, data)
  },
  resetChallenges({ commit }, data) {
    commit(types.RESET_CHALLENGES, data)
  },
  setChallengeData({ commit }, data) {
    commit(types.SET_CHALLENGE_DATA, data)
  },
  async getChallenges({ commit }, data) {
    const r = await http.get(`v2/challenges/view`, {
      params: data,
    })
    commit(types.SET_CHALLENGES, r.data.data)
    return r.data.data
  },
  async getChallengeList({ commit }, data) {
    const r = await http.get(`v2/challenges/list`, {
      params: data,
    })
    commit(types.SET_CHALLENGES, r.data)
    return r.data.data
  },
  async getChallenge({ commit }, id) {
    const r = await http.get(`v2/challenges/get/${id}`)
    commit(types.SET_CHALLENGE, r.data.data)
    return r.data.data
  },
  async editChallenge({ commit }, id) {
    const r = await http.get(`v2/challenges/edit/${id}`)
    commit(types.SET_CHALLENGE, r.data.data)
    return r.data.data
  },
  async saveChallenge({ commit }, data) {
    const r = await http.post('v2/challenges/save', data)
    commit(types.SAVED_CHALLENGE, r.data.data)
    return r.data.data
  },
  async removeChallenge({ commit }, data) {
    const r = await http.post('v2/challenges/delete', data)
    return r.data.data
  },
  async recalcChallengeProgress({ commit }, data) {
    const r = await http.post(
      `v2/challenges/recalculatechallengeprogress`,
      data
    )
    return r.data.data
  },
  async getChallengeName({ commit }, id) {
    const r = await http.get(`v2/challenges/challengename/${id}`)
    commit(types.SET_CHALLENGENAME, r.data.data)
    return r.data.data
  },
}
